import React, { useState } from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import { JsonInput } from './fields';

// Ham JSON: bir kökü (client, staticOptions…) bütün olarak düzenleme + şemada tanımı olmayan anahtarlar.

export function uncoveredKeys(doc, fields, root) {
	let bag = doc && doc[root];
	if (!_.isPlainObject(bag)) return [];
	return _.filter(_.keys(bag), (k) => {
		let path = root + '.' + k;
		return !_.some(fields, (f) => f.path === path || f.path.indexOf(path + '.') === 0 || path.indexOf(f.path + '.') === 0);
	});
}

// DB'de elle yapılan "kapatma" alışkanlığı: _hide_closed, xmessageSetting, 1force_logout_mobil, workingHours1…
function classify(name, known) {
	if (name !== name.trim() || /\s/.test(name)) return { label: 'adında boşluk var', cls: 'danger', hint: 'Bu haliyle okunmaz: "' + name.trim() + '"' };
	let stripped = name.replace(/^[_x1-]+/, '').replace(/[0-9_]+$/, '');
	if (stripped !== name && known(stripped)) return { label: 'kapatılmış kopya', cls: 'warn', hint: 'Etkin alan: ' + stripped };
	return { label: 'tanımsız', cls: '' };
}

// agent paneli sadece staticOptions'ı, widget sadece client'ı okur
function misplaced(rootKey, name, knownPath) {
	if (rootKey === 'client' && knownPath('staticOptions.' + name))
		return { label: 'yanlış yerde', cls: 'warn', hint: "Agent ayarı; client'ta etkisi yok. Agent Ekranı › staticOptions." + name };
	if (rootKey === 'staticOptions' && knownPath('client.' + name))
		return { label: 'yanlış yerde', cls: 'warn', hint: "Widget ayarı; staticOptions'ta etkisi yok. Widget › client." + name };
	return null;
}

const IDENTITY_ROOTS = ['_id', 'id', 'token', 'stoken', '_token', 'wid', 'owner', 'agents', 'name', 'premium', 'state', 'bot', 'bot2', 'bots', 'whatsapp_bot', 'waba_bot', 'cronOptions', 'cronPeriod', '_collectaction_uid', '__v', 'createDate', 'updateDate'];

export default function RawTab({ doc, fields, roots, getValue, setValue, isChanged }) {
	const [root, setRoot] = useState('staticOptions');
	let objectRoots = _.filter(roots, (r) => _.isPlainObject(doc[r]));
	let extras = _.flatMap(objectRoots, (r) => _.map(uncoveredKeys(doc, fields, r), (k) => r + '.' + k));
	let known = (path) => _.some(fields, (f) => f.path === path || f.path.indexOf(path + '.') === 0);
	let strangeRoots = _.filter(_.keys(doc), (k) => roots.indexOf(k) === -1 && IDENTITY_ROOTS.indexOf(k) === -1);

	return (
		<div>
			<div className="yta-card">
				<div className="yta-card-head">
					<Icon name="question circle outline" />
					Şemada tanımı olmayan alanlar
					<span className="yta-count">{extras.length}</span>
					<span className="yta-muted">Hesapta var ama formlarda yok; buradan düzenlenir. Kalıcı form için Alan Tanımları'na ekleyin.</span>
				</div>
				<div className="yta-card-body">
					{extras.length ? (
						_.map(extras, (path) => {
							let rootKey = path.split('.')[0];
							let name = path.slice(rootKey.length + 1);
							let c = misplaced(rootKey, name, known) || classify(name, (n) => known(rootKey + '.' + n));
							return (
							<div key={path} className={'yta-field' + (isChanged(path) ? ' changed' : '')}>
								<div>
									<div className="yta-field-label">
										{JSON.stringify(name).slice(1, -1)}
										<span className={'yta-badge ' + c.cls}>{c.label}</span>
									</div>
									<div className="yta-field-key">{path}</div>
									{c.hint ? <div className="yta-field-desc">{c.hint}</div> : null}
								</div>
								<JsonInput value={getValue(path)} rows={_.isObject(getValue(path)) ? 5 : 1} onChange={(v) => setValue(path, v)} />
								<div className="yta-field-side">
									<button className="yta-iconbtn" title="Alanı sil" onClick={() => setValue(path, undefined)}>
										<Icon name="trash alternate outline" />
									</button>
								</div>
							</div>
							);
						})
					) : (
						<div className="yta-muted">Hepsi tanımlı.</div>
					)}
				</div>
			</div>

			{strangeRoots.length ? (
				<div className="yta-card">
					<div className="yta-card-head">
						<Icon name="archive" />
						Kök seviyesinde tanınmayan alanlar
						<span className="yta-count">{strangeRoots.length}</span>
						<span className="yta-muted">Kodda okunmuyor (çoğu elle kapatılmış kopya). Panelden yazılamaz, sadece gösterilir.</span>
					</div>
					<div className="yta-card-body">
						{_.map(strangeRoots, (k) => {
							let c = classify(k, (n) => roots.indexOf(n) !== -1 || IDENTITY_ROOTS.indexOf(n) !== -1);
							return (
								<div key={k} className="yta-field">
									<div>
										<div className="yta-field-label">
											{JSON.stringify(k).slice(1, -1)}
											<span className={'yta-badge ' + c.cls}>{c.label}</span>
										</div>
										{c.hint ? <div className="yta-field-desc">{c.hint}</div> : null}
									</div>
									<pre className="yta-mono" style={{ margin: 0, maxHeight: 160, overflow: 'auto' }}>
										{_.truncate(JSON.stringify(doc[k], null, 2), { length: 2000 })}
									</pre>
									<div />
								</div>
							);
						})}
					</div>
				</div>
			) : null}

			<div className="yta-card">
				<div className="yta-card-head">
					<Icon name="code" />
					Ham düzenleme
					<Dropdown
						inline
						scrolling
						search
						value={root}
						options={_.map(roots, (r) => ({ key: r, value: r, text: r }))}
						onChange={(e, d) => setRoot(d.value)}
						style={{ fontWeight: 400 }}
					/>
					<span className="yta-muted">Bu kökün tamamı değiştirilir; aynı kökteki diğer bekleyen değişiklikler buna katılır.</span>
				</div>
				<div className="yta-card-body">
					<JsonInput key={root} value={getValue(root)} rows={26} onChange={(v) => setValue(root, v)} />
				</div>
			</div>
		</div>
	);
}
